export default __webpack_public_path__ + "static/media/xbetting24_receipt.f382015c.jpg";